import type { ComponentType, ReactNode, SVGProps } from "react";
import { ArrowUpRight } from "lucide-react";
import { businessConfig } from "../content/siteContent";
import { track, type AnalyticsEvent } from "../lib/analytics";

export function BookingLink({
  children,
  event,
  className = "",
}: {
  children: ReactNode;
  event: Extract<AnalyticsEvent, `${string}_booking_click`>;
  className?: string;
}) {
  return (
    <a
      href={businessConfig.bookingUrl}
      target="_blank"
      rel="noreferrer"
      onClick={() => track(event)}
      className={`button button-primary ${className}`}
    >
      {children}
      <ArrowUpRight aria-hidden="true" size={17} strokeWidth={2} />
    </a>
  );
}

export function SmsLink({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <a
      href={`sms:${businessConfig.phoneDigits}`}
      onClick={() => track("sms_click")}
      className={`button button-secondary ${className}`}
    >
      {children}
    </a>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  copy,
  align = "left",
}: {
  eyebrow: string;
  title: string;
  copy?: string;
  align?: "left" | "center";
}) {
  return (
    <header className={`section-heading ${align === "center" ? "section-heading-center" : ""}`}>
      <p className="eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
      {copy && <p className="section-copy">{copy}</p>}
    </header>
  );
}

export function ResponsiveImage({
  src,
  alt,
  eager = false,
  className = "",
}: {
  src: string;
  alt: string;
  eager?: boolean;
  className?: string;
}) {
  return (
    <img
      src={src}
      alt={alt}
      width={eager ? 1536 : 1128}
      height={eager ? 1024 : 1410}
      loading={eager ? "eager" : "lazy"}
      fetchPriority={eager ? "high" : "auto"}
      decoding="async"
      className={className}
    />
  );
}

export function IconText({
  icon: Icon,
  title,
  text,
}: {
  icon: ComponentType<SVGProps<SVGSVGElement> & { size?: number | string; strokeWidth?: number | string }>;
  title: string;
  text: string;
}) {
  return (
    <div className="icon-text">
      <span className="icon-box"><Icon size={20} strokeWidth={1.8} aria-hidden="true" /></span>
      <div><h3>{title}</h3><p>{text}</p></div>
    </div>
  );
}
